// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TemplateDownloader from './sources/TemplateDownloader';
import Button from './common/Button';
// css
import '../styles/components/TemplateDownloaderPage.scss';


class TemplateDownloaderPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downloaded: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(settings) {
    this.setState({ downloaded: true });
    return this.props.onDownloadTemplates(settings);
  }

  renderDownloader() {
    if (!this.state.downloaded) {
      return (
        <TemplateDownloader
          allowCancel={false}
          onSubmit={this.handleSubmit}
          dsaType={this.props.dsaType}
        />
      );
    }
  }

  renderAfterDownloadMessage() {
    if (this.state.downloaded) {
      return (
        <div className='template-downloader-page__after-download-message'>
          <p>After you fill out the XLS templates with your sources data, create a new DSA and import them.</p>
          <Button
            primary
            href='/welcome'
            label='Go to Accounts View'
          />
        </div>
      );
    }
  }

  getHumanizedDSAType() {
    const { dsaType } = this.props;
    return dsaType === 'full' ? 'Full' : 'New Customer';
  }

  render() {
    return (
      <div className='template-downloader-page'>
        <h2>Download {this.getHumanizedDSAType()} DSA Template Files</h2>
        {this.renderDownloader()}
        {this.renderAfterDownloadMessage()}
      </div>
    );
  }
}

TemplateDownloaderPage.propTypes = {
  onDownloadTemplates: PropTypes.func.isRequired,
  dsaType: PropTypes.string.isRequired
};

export default TemplateDownloaderPage;



// WEBPACK FOOTER //
// ./src/components/TemplateDownloaderPage.js